import React from 'react';
import { View, Text } from 'react-native';
import { useTranslation } from '@oolio-group/localization';
import { VOIDED_TEXT } from '../../../common/constants';
import DocketItemStyles from '../DocketItem.styles';

const DocketVoidLabel: React.FC = () => {
  const styles = DocketItemStyles();
  const { translate } = useTranslation();
  return (
    <View
      testID="docket-voided"
      style={[styles.statusContainer, styles.voidedContainer]}
    >
      <Text style={[styles.statusTextUppercase, styles.voidedText]}>
        {translate(`kitchenDisplay.${VOIDED_TEXT}`)}
      </Text>
    </View>
  );
};

export default React.memo(DocketVoidLabel);
